/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 1:43 PM
 *
 */

import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAppSelector } from 'stores';

import { useNestedMemberList } from 'features/members/api/query/useNestedMemberList';

import ErrorState from 'components/ErrorState';
import { TableView } from 'components/Table';

import MemberTableRow from '../MemberTableRow';
import MemberFilter from '../../filter/MemberFilter';

/**
 *
 * @constructor
 */
export default function MemberTable() {
  const [params] = useSearchParams();
  const currentRole = useAppSelector((state) => state.members.role);

  const [filterParams, setFilterParams] = useState('');
  const [searchTerms, setSearchTerm] = useState('');

  const user = useAppSelector((state) => state.auth.user);

  const { data: usersList, isLoading } = useNestedMemberList(
    currentRole?.id ?? 0,
    user?.id ?? 1,
    undefined,
    Number(params.get('page') ?? 1),
    true,
    filterParams,
    searchTerms
  );

  useEffect(() => {
    window.scroll(0, 0);
  }, [params.get('page')]);

  return !currentRole ? (
    <ErrorState title="No Member Found" subtitle="Please switch role or add a new member" />
  ) : (
    <>
      {
        <TableView
          searchTerm={searchTerms}
          setFilterParams={setFilterParams}
          setSearchTerm={setSearchTerm}
          data={usersList?.list}
          tableHeadings={['Member Name', 'Member Code', 'Verified', 'Phone Number', 'Address', '']}
          filterComponent={
            <MemberFilter
              id={currentRole.id}
              setFilterParams={setFilterParams}
              userid={Number(user?.id)}
            />
          }
          search={true}
          error={usersList ? false : true}
          loading={isLoading}
          searchTerms={['name', 'member_code']}
          tableRowComponent={<MemberTableRow />}
          paginate={true}
          paginateObject={usersList?.pagination}
        />
      }
    </>
  );
}
